import type { PeopleExtension as PeopleExtensionModel } from '@/adapters/catalogv1.g';

export function extractPeopleExtension(model: PeopleExtensionModel) {
  const attributes = model.attributes ?? [];

  return {
    id: model._metadata?.distinct_id ?? '',
    personRef: model.person_ref ?? '',
    attributes,
    attributeCount: attributes.length,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogPeopleExtension = ReturnType<typeof extractPeopleExtension>;
